<template>
  <section id="product-services" class="product-services-section">
    <div class="container">
      <div class="section-title">
        <div class="en-label">{{ $t('productServices.eyebrow') }}</div>
        <h2>{{ $t('productServices.title') }}</h2>
        <p>{{ $t('productServices.desc') }}</p>
      </div>

      <div class="service-grid">
        <article
          v-for="item in normalizedServices"
          :key="item.id"
          class="service-card"
          :class="item.theme">
          <div class="card-top">
            <div class="service-icon"><i :class="item.icon"></i></div>
            <span class="service-badge" v-if="item.badge">{{ item.badge }}</span>
          </div>
          <h3>{{ item.name }}</h3>
          <p>{{ item.desc }}</p>
          <ul>
            <li v-for="point in item.points" :key="point">{{ point }}</li>
          </ul>
          <div class="service-foot">
            <a href="javascript:void(0)">{{ $t('productServices.detailLink') }} <i class="el-icon-arrow-right"></i></a>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
const serviceMeta = {
  hematology: { icon: 'el-icon-cpu', theme: 'purple' },
  reproduction: { icon: 'el-icon-s-data', theme: 'green' },
  biochemistry: { icon: 'el-icon-picture-outline', theme: 'blue' },
  microbiology: { icon: 'el-icon-zoom-in', theme: 'pink' },
  molecular: { icon: 'el-icon-share', theme: 'cyan' },
  more: { icon: 'el-icon-upload2', theme: 'gold' }
}

export default {
  name: 'ProductServicesSection',
  computed: {
    normalizedServices() {
      return this.$tm('productServices.services').map(service => ({
        ...service,
        ...serviceMeta[service.id]
      }))
    }
  }
}
</script>

<style lang="less" scoped>
.product-services-section {
  padding: 110px 0 120px;
  background: #fff;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 26px;
}

.service-card {
  min-height: 365px;
  border: 1px solid #e3e9ef;
  border-radius: 16px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  transition: transform .25s, box-shadow .25s;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 18px 48px rgba(21, 45, 71, .12);
}

.purple { background: linear-gradient(135deg, #f6f3ff, #fbfaff); border-color: #d6c9ff; }
.green { background: linear-gradient(135deg, #effcf9, #f7fffd); }
.blue { background: linear-gradient(135deg, #f0f8fc, #f8fcff); }
.pink { background: linear-gradient(135deg, #fff4f8, #fffafd); }
.cyan { background: linear-gradient(135deg, #eefcff, #f8feff); }
.gold { background: linear-gradient(135deg, #fff9eb, #fffdf7); }

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.service-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, #009a9a, #00bfa5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 23px;
}

.service-badge {
  padding: 4px 8px;
  border-radius: 12px;
  background: rgba(10, 115, 183, .1);
  color: #0a73b7;
  font-size: 12px;
  font-weight: 800;
}

h3 {
  font-size: 19px;
  color: var(--text-dark);
  margin: 0 0 14px;
  line-height: 1.35;
}

p {
  color: var(--text-mid);
  font-size: 14px;
  line-height: 1.8;
  margin: 0 0 18px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0 0 22px;
}

li {
  color: var(--text-mid);
  font-size: 13px;
  line-height: 1.9;
}

li::before {
  content: "·";
  color: #00bfa5;
  font-weight: 900;
  margin-right: 8px;
}

.service-foot {
  margin-top: auto;
  padding-top: 18px;
  border-top: 1px solid rgba(21, 45, 71, .08);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.service-foot a {
  color: #0a73b7;
  font-size: 13px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 980px) {
  .service-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .product-services-section {
    padding: 88px 0;
  }

  .service-grid {
    grid-template-columns: 1fr;
  }
}
</style>
